import { patchAssessment } from '@actions/assessments';
import {
    getAssessmentsIsPatching,
    getAssessmentsPatchError,
    getAssessmentsPatchSuccess,
} from '@selectors/assessments';
import useForm from '@components/form/hooks/useForm';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Assessment, PatchAssessment } from 'src/types/shared/Assessments';

const useEditAssessmentForm = (assessment: Assessment, onSuccess: () => void) => {
    const dispatch = useDispatch();

    const isPatching = useSelector(getAssessmentsIsPatching);
    const patchSuccess = useSelector(getAssessmentsPatchSuccess);
    const patchError = useSelector(getAssessmentsPatchError);

    const [data, handleChange, _, initForm] = useForm<PatchAssessment>({
        applicationID: assessment.applicationID,

        deploymentScale: assessment.deploymentScale,
        fitWithChallenge: assessment.fitWithChallenge,
        credibilityCompany: assessment.credibilityCompany,
        credibilityTechnology: assessment.credibilityTechnology,
        fullOrPartialSolution: assessment.fullOrPartialSolution,

        isInnovative: assessment.isInnovative,
        finalComment: assessment.finalComment ?? '',
    });

    const prevPatchSuccess = usePrevious(patchSuccess);
    useEffect(() => {
        if (!prevPatchSuccess && patchSuccess) onSuccess();
    }, [patchSuccess, prevPatchSuccess, onSuccess]);

    const handleSubmit = () => {
        dispatch(patchAssessment(data));
    };

    return { data, handleChange, handleSubmit, isPatching, patchSuccess, patchError, initForm };
};

export default useEditAssessmentForm;
